import { State } from "@/stores/trip/types.ts";
export default {
  getTripListResponse: (state: State) => state.tripListResponse,
};
